<template>
    <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManageHeaderFooter") }}r</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4">
   
            <div class="d-flex flex-column gap-4">
                <div class="d-flex flex-column">
                    <v-label class="mb-2" style="font-size: 1rem;">Header</v-label>
                    <div class="d-flex gap-2d">
                        <v-file-input accept=".jpg,.jpeg,.png" solo v-model="uploadedHeaderImage" @change="onUploadedHeaderImageChange" prepend-icon=""></v-file-input>
                        <v-btn @click="uploadFile(uploadedHeaderImage, true)" color="primary ml-2" width="100">{{ $t("res_ButtonText_Save") }}</v-btn>
                    </div>
                    <div class="mt-6">
                        <label>
                            {{ headerData == '#' ? "No Header" : "Choosen Header" }}
                        </label>
                        <div class="mt-2" style="width: 150px;">
                            <v-img v-if="headerData!='#'" max-height="200" max-width="150" :src=headerData></v-img>
                            <v-img max-width="250" v-else src="/assets/images/icons/no_preview.svg"></v-img>
                            <v-btn @click="deleteStructureHeaderFooter(true)" color="error" class="mt-2" style="width: 100%;" v-if="headerData!='#' && isOrginalHeader">{{ $t("res_ButtonText_Delete") }}</v-btn>
                        </div>
                    </div>
                </div>


                <div class="d-flex flex-column">
                    <v-label class="mb-2" style="font-size: 1rem;">Footer</v-label>
                    <div class="d-flex gap-2">
                        <v-file-input  accept=".jpg,.jpeg,.png" solo v-model="uploadedFooterImage" @change="onUploadedFooterImageChange" prepend-icon=""></v-file-input>
                        <v-btn @click="uploadFile(uploadedFooterImage, false)" color="primary ml-2" width="100">{{ $t("res_ButtonText_Save") }}</v-btn>
                    </div>
                    <div class="mt-6">
                        <label>
                            {{ footerData == '#' ? "No Footer" : "Choosen Footer" }}
                        </label>
                        <div class="mt-2" style="width: 150px;">
                            <v-img v-if="footerData!='#'" max-height="150" max-width="150" :src=footerData></v-img>
                            <v-img max-width="150" v-else src="/assets/images/icons/no_preview.svg"></v-img>
                            <v-btn @click="deleteStructureHeaderFooter(false)" color="error" class="mt-2" style="width: 100%;" v-if="footerData!='#' && isOrginalFooter">{{ $t("res_ButtonText_Delete") }}</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';

export default {
    name: 'ManageStructureHeaderFooter',
    props: {
        structure_id: Number,
    },
    data() {
        return {
            isOrginalHeader: false,
            isOrginalFooter: false,
            uploadedHeaderImage: {},
            uploadedFooterImage: {},
            headerData: "#",
            footerData: "#",
        }
    },
    methods: {
        createImage(file, isHeader) {
            this.isOrginalStamp = false;
            const reader = new FileReader();
            reader.onload = e => {
                if(isHeader)
                {
                    this.headerData = e.target.result;
                    this.isOrginalHeader = false;
                }
                else
                {
                    this.footerData = e.target.result;
                    this.isOrginalFooter = false;
                }
            };
            reader.readAsDataURL(file);
        },
        onUploadedHeaderImageChange() {
            if(this.uploadedHeaderImage == null || this.uploadedHeaderImage == undefined)
            {
                this.getStructureHeaderFooter();
                this.getUploadStructureHeaderFooter(true);
                return;
            }
            if(this.uploadedHeaderImage.size == 0)
                return
            this.createImage(this.uploadedHeaderImage, true)
        },
        onUploadedFooterImageChange() {
            if(this.uploadedFooterImage == null || this.uploadedFooterImage == undefined)
            {
                this.getStructureHeaderFooter();
                this.getUploadStructureHeaderFooter(false);
                return;
            }
            if(this.uploadedFooterImage.size == 0)
                return
            this.createImage(this.uploadedFooterImage, false)
        },
        async deleteStructureHeaderFooter(isHeader) {
            try {
                const res = await axios.post(constants.baseApiUrl + 'Admin/DeleteStructureHeaderFooter?structureId=' + this.structure_id + '&isHeader=' + isHeader);
                if (res.data != 0) {
                    window.showAlert('res_Msgs_StampDeleted', 'success');
                    if(isHeader) {
                        this.headerData = "#";
                        this.uploadedHeaderImage = {};
                    }
                    else {
                        this.footerData = "#";
                        this.uploadedFooterImage = {};
                    }
                    this.getStructureHeaderFooter();
                }
                else
                    window.showAlert('res_Msgs_ErrorOccured', 'error');
            } catch (error) {
                console.warn(error);
            }
        },
        uploadFile(file, isHeader) {
            let attachments = new FormData();
            attachments.append('structureId', this.structure_id)
            attachments.append('isHeader', isHeader)
            attachments.append('originalMail[0]', file)
            const headers2 = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };
            axios.post(constants.baseApiUrl + 'Admin/UploadStructureHeaderFooter', attachments, { headers: headers2 })
                .then(response => {
                    //;
                    if (response == undefined || response.data == null) {
                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                    } else {
                        window.showAlert('res_Msgs_StampUploaded', 'success');
                        this.getStructureHeaderFooter();
                    }
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        },
        async getStructureHeaderFooter() {
            try {
                window.showLoading();
                const response = await axios.get(constants.baseApiUrl + 'Admin/GetStructureHeaderFooter?structureId=' + this.structure_id);
                const data = response.data;
                if(data == null || data == undefined || data.length == 0)
                {
                    this.headerData = "#";
                    this.footerData = "#";
                    return;
                }
                data.forEach(item => {
                    if (item.isHeader) {
                        this.getUploadStructureHeaderFooter(true);
                        this.headerData = "data:image/png;base64," + item.image;
                        this.isOrginalHeader = true;
                    }
                    else {
                        this.getUploadStructureHeaderFooter(false);
                        this.footerData = "data:image/png;base64," + item.image;
                        this.isOrginalFooter = true;
                    }
                });
            }
            catch (err) {
                console.warn(err);
            }
            finally {
                window.hideLoading();
            }
        },
        reset() {
            this.uploadedHeaderImage = {};
            this.uploadedFooterImage = {};
            this.headerData = "#";
            this.footerData = "#";
        },
        async getUploadStructureHeaderFooter(isHeader)
        {
            try
            {
                const res = await axios.get(constants.baseApiUrl + 'Admin/GetUploadedStructureHeaderFooter?structureId=' + this.structure_id + '&isHeader=' + isHeader);
                if (res.data != "" && res.data != null)
                {
                    var blob = new Blob([new Uint8Array(res.data.item2)], { type: 'image/png' });
                    if(isHeader)
                        this.uploadedHeaderImage = new File([blob], res.data.item1, { type: 'image/png' });
                    else
                        this.uploadedFooterImage = new File([blob], res.data.item1, { type: 'image/png' });
                }
                else
                {
                    if(isHeader)
                        this.uploadedHeaderImage = {};
                    else
                        this.uploadedFooterImage = {};
                }
            }
            catch (err)
            {
                console.warn(err);
            }
        },
    },
    mounted() {
        this.getStructureHeaderFooter();
    },
    watch: {
        structure_id: function() {
            this.reset();
            this.getStructureHeaderFooter();
        }
    }
}

</script>

<style scoped>
</style>